import { render, staticRenderFns } from "./SearchCausaExternaComponent.vue?vue&type=template&id=47b87d3a&"
import script from "./SearchCausaExternaComponent.vue?vue&type=script&lang=js&"
export * from "./SearchCausaExternaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports